var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"toast-fade"}},[(_vm.isVisible)?_c('div',{staticClass:"toast-container"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }